/** @format */

import React from 'react'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <div className="center p-8">
      <p className="mb-4">
        <a
          className="secondaryLink"
          title="Formspree on Twitter"
          href="https://twitter.com/formspree"
          target="_blank"
        >
          Twitter
        </a>
        {' | '}
        <a
          className="secondaryLink"
          title="Formspree on Facebook"
          href="https://facebook.com/formspree"
          target="_blank"
        >
          Facebook
        </a>
        {' | '}
        <a
          className="secondaryLink"
          title="Formspree on GitHub"
          href="https://github.com/formspree"
          target="_blank"
        >
          GitHub
        </a>
      </p>
      <p className="text-sm text-gray-600">
        © {year} Formspree, Inc.
        <br />
        Please check out our{' '}
        <a
          className="primaryLink text-xs"
          title="Visit the Formspree Help Site"
          href="https://help.formspree.io"
          target="_blank"
        >
          Help Site
        </a>
        ,{' '}
        <a
          className="primaryLink text-xs"
          title="Formspree Terms of Use"
          href="https://formspree.io/legal/terms-of-service"
          target="_blank"
        >
          Terms of Use
        </a>
        , and{' '}
        <a
          className="primaryLink text-xs"
          title="Formspree Privacy Policy"
          href="https://formspree.io/legal/privacy-policy"
          target="_blank"
        >
          Privacy Policy
        </a>
        .
      </p>
    </div>
  )
}
